module.exports = __webpack_public_path__ + "img/logo40px.32ce5662.svg";